import { getShipiumBaseHost, getShipiumDomain } from '~/utils/shipiumDomain';

export const shipiumApplicationUrlHelper = (locationHostName: string, shipiumApplicationName: string) => {
  const { isLocal, regionSuffix } = getShipiumDomain(locationHostName);
  const baseHost = getShipiumBaseHost(locationHostName);

  if (isLocal) {
    return `http://${shipiumApplicationName}.${baseHost}`;
  }
  return `https://${shipiumApplicationName}${regionSuffix}.${baseHost}`;
};
